module.exports = __webpack_public_path__ + "static/media/loading.f07e193f.svg";